import { get } from 'lodash';
import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import CreateForm from '../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../context/ApplicationContext';
import { APIS } from '../../../../lib/constants/apis';
import { FormStrucItem } from '../../../../lib/types/types';

// import schemas
import AbschlusberichtSchema from '../../../../lib/paths/abschlussbericht_FULL_Paths.json';
import AntragSchema from '../../../../lib/paths/antrag_FULL_Paths.json';
import MittelabrufSchema from '../../../../lib/paths/mittelabruf_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import ZwischenBerichtSchema from '../../../../lib/paths/zwischenbericht_FULL_Paths.json';
const P = AntragSchema.attributes;
const MA_P = MittelabrufSchema.attributes;
const VN_P = VerwendungsnachweisSchema.attributes;
const ZN_P = ZwischenBerichtSchema.attributes;
const AB_P = AbschlusberichtSchema.attributes;

const HinweisAnDieHaFeld: FC<{ formStruc?: FormStrucItem[] }> = ({ formStruc }) => {
	const location = useLocation();
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<CreateForm
			formStruc={formStrucUpload(get(location, 'state.api'), formStruc)}
			formValues={application}
			updateFormValuesFunc={setApplicationProperty}
			readOnly={readOnly}
		/>
	);
};

export default HinweisAnDieHaFeld;

const formStrucUpload = (api: string, formStruc?: FormStrucItem[]) => {
	if (formStruc) {
		return formStruc;
	}

	let struc: FormStrucItem[] = [];

	switch (api) {
		case APIS.Antrag:
			struc = [{ fields: [P.Allgemein_Hinweise_An_Die_HA], userProps: { direction: 'column', columnToDivide: 1 } }];
			break;
		case APIS.Mittelabruf:
			struc = [{ fields: [MA_P.Allgemein_Hinweise_An_Die_HA], userProps: { direction: 'column', columnToDivide: 1 } }];
			break;
		case APIS.Verwendungsnachweis:
			struc = [{ fields: [VN_P.Allgemein_Hinweise_An_Die_HA], userProps: { direction: 'column', columnToDivide: 1 } }];
			break;
		case APIS.Zwischenbericht:
			struc = [{ fields: [ZN_P.Allgemein_Hinweise_An_Die_HA], userProps: { direction: 'column', columnToDivide: 1 } }];
			break;
		case APIS.Abschlussbericht:
			struc = [{ fields: [AB_P.Allgemein_Hinweise_An_Die_HA], userProps: { direction: 'column', columnToDivide: 1 } }];
			break;
	}

	return struc;
};
